import React from 'react'
import "./AcceleratorDetails.scss"
import edit from "../../../Assets/Images/edit.svg"
import right from "../../../Assets/Images/right-approve.svg"
import reject from "../../../Assets/Images/reject.svg"
import { Col, Row } from 'antd'

const AcceleratorDetails = () => {
    return (
        <div className='details-container'>
            <div className='details-wrapper-top'>
                <h6>Accelerator</h6>
                <div className="on-right">
                    <p
                    //  onClick={() => onDeleteTalent()}
                    >
                        <img src={right} alt="edit" />
                        <span>Approve</span>
                    </p>
                    <p
                    //  onClick={() => onDeleteTalent()}
                    >
                        <img src={reject} alt="edit" />
                        <span>Reject</span>
                    </p>
                    <p
                    //  onClick={() => history.push(`/talent/talent-edit/${talentId}`)}
                    >
                        <img src={edit} alt="edit" />
                        <span>Edit</span>
                    </p>
                </div>
            </div>
            <div className="details-wrapper-data-wrap">
                <div className="details-wrapper-section">
                    <h2>Founder 1</h2>
                    <Row gutter={24}>
                        <Col span={12}>
                            <div className="label">Full name</div>
                            <p>john smith</p>
                        </Col>
                        <Col span={12}>
                            <div className="label">Email</div>
                            <p>johnsmith@gmail.com</p>
                        </Col>
                        <Col span={24}>
                            <div className="label">Role & Skillset</div>
                            <p>CFO; Strong background in finance, fundraising, and financial modeling. Expertise in managing budgets, forecasting, financial planning, and investor relations.</p>
                        </Col>
                        <Col span={12}>
                            <div className="label">Link (LinkedIn)</div>
                            <p>linkedin.com/name</p>
                        </Col>
                        <Col span={12}>
                            <div className="label">Link (Personal Website)</div>
                            <p>Website name.com</p>
                        </Col>
                    </Row>
                </div>
                <div className="details-wrapper-section">
                    <h2>The Idea</h2>
                    <Row gutter={24}>
                        <Col span={24}>
                            <div className="label">Startup name</div>
                            <p>Fundraising Pro</p>
                        </Col>
                        <Col span={24}>
                            <div className="label">Who is it for?</div>
                            <p>It’s for non-profits, startups, and social enterprises that need to raise funds but struggle to find the right investors or donors.</p>
                        </Col>
                        <Col span={24}>
                            <div className="label">What are you building</div>
                            <p>Fundraising Pro is a platform designed to simplify the fundraising process for non-profits and startups, helping them connect with investors, donors, and funding sources.</p>
                        </Col>
                        <Col span={24}>
                            <div className="label">Why does it matter</div>
                            <p>Access to funding is one of the biggest hurdles faced by organizations, especially smaller ones. Fundraising Pro solves this by connecting them to the right sources, making the process faster and more efficient.</p>
                        </Col>
                    </Row>
                </div>

                <div className="details-wrapper-section">
                    <h1>Progress</h1>
                    <Row gutter={24}>
                        <Col span={24}>
                            <div className="label">Early steps taken</div>
                            <p>We’ve completed preliminary market research, conducted customer interviews, and created an early-stage prototype of the platform. We're currently testing the prototype with a small group of users.</p>
                        </Col>
                    </Row>
                </div>

                <div className="details-wrapper-section">
                    <h1>Vision</h1>
                    <Row gutter={24}>
                        <Col span={24}>
                            <div className="label">5-year vision</div>
                            <p>In five years, Fundraising Pro could become the go-to platform for organizations worldwide to access funding, providing a seamless, global network of investors, donors, and partners. We envision expanding to multiple industries, including tech startups, educational projects, and healthcare initiatives.</p>
                        </Col>
                    </Row>
                </div>
                <div className="details-wrapper-section">
                    <h1>Fit for Exitfund Accelerator</h1>
                    <Row gutter={24}>
                        <Col span={24}>
                            <div className="label">Why now?</div>
                            <p>With the increasing number of startups and non-profits needing funding solutions, the timing is perfect to scale Fundraising Pro and help address this urgent need.</p>
                        </Col>
                        <Col span={24}>
                            <div className="label">Why you?</div>
                            <p>My experience in both fundraising and technology makes me uniquely qualified to build a platform that meets the needs of both fundraisers and investors. I am passionate about helping organizations succeed.</p>
                        </Col>
                        <Col span={24}>
                            <div className="label">Why this program?</div>
                            <p>Exitfund Accelerator offers the expertise and network to help scale our solution quickly. Their focus on early-stage startups and growth matches our current needs and future aspirations.</p>
                        </Col>
                    </Row>
                </div>

                <div className="details-wrapper-section">
                    <h1>Founder Introduction Video</h1>
                    <Row gutter={24}>
                        <Col span={24}>
                            <div className="label">Link to a short 60-second founder intro video</div>
                            <p>Url</p>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
    )
}

export default AcceleratorDetails